import React, { useRef, useState, useEffect } from "react";
import { Carousel } from "antd";
import styles from "./CardBanner.module.scss";
import ModalStartTrial from "../../../pages/Payment/ModalPayment/ModalStartTrial";
import ModalGetPackage from "../../../pages/Payment/ModalPayment/ModalGetPackage";
import { getNews } from "api/master";
import { useFetchList } from "services/fetchList";
import SkeletonCardBanner from "components/Skeleton/Banner/SkeletonCardBanner";
import useWindowSize from "hook/useWindowSize";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CardBanner = (props) => {
  const [visibleTrial, setVisibleTrial] = useState(false);
  const [visibleGetPkg, setVisibleGetPkg] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);

  const slider = useRef();
  const [{ dataList, isLoading }, doFetch] = useFetchList(getNews, {}, []);
  const { width } = useWindowSize();
  const history = useHistory();

  const [now, setNow] = useState(Math.floor(Date.now() / 1000));
  const [bannerList, setBannerList] = useState([]);

  // Update `now` every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Math.floor(Date.now() / 1000));
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  // Update visible banners when `dataList` or `now` changes
  useEffect(() => {
    const list = dataList?.list || [];
    const visible = list.filter((banner) => {
      if (!banner.showDurationEnable) return true;
      return banner.startShowDuration <= now && now <= banner.endShowDuration;
    });
    setBannerList(visible);
  }, [dataList, now]);

  const handleClickBanner = (r) => {
    if (r.goToPage === "selectRound" || r.goToPage === "selectRoundPrice") {
      history.push(`/landingform?id=${r.id}`, { from: r.goToPage, id: r.id });
    } else if (r.goToPage === "listAll") {
      history.push(r.type === "PRETEST" ? "/bundle" : "/pretest");
    } else if (r.goToPage === "myProduct") {
      history.push(
        "/myExam",
        r.type === "PRETEST" ? { from: "form" } : undefined
      );
    } else if (r.goToPage === "ranking") {
      history.push(`/result-landing?id=${r.id}`);
    }
  };

  const handleBeforeChange = (current, next) => {
    const targetBanner = bannerList?.[next];
    if (!targetBanner) return;

    const isVisible =
      !targetBanner.showDurationEnable ||
      (targetBanner.startShowDuration <= now &&
        now <= targetBanner.endShowDuration);

    if (!isVisible) {
      const total = bannerList?.length || 0;
      for (let i = 1; i < total; i++) {
        const nextIndex = (next + i) % total;
        const nextBanner = bannerList?.[nextIndex];
        const nextVisible =
          !nextBanner?.showDurationEnable ||
          (nextBanner?.startShowDuration <= now &&
            now <= nextBanner?.endShowDuration);

        if (nextVisible) {
          slider.current?.goTo(nextIndex);
          return;
        }
      }
      return;
    }

    setCarouselIndex(next);
  };

  return (
    <div>
      {isLoading ? (
        <SkeletonCardBanner />
      ) : bannerList.length > 0 ? (
        <Carousel
          dots={true}
          autoplay
          ref={(ref) => (slider.current = ref)}
          className={styles.cardContainer}
          style={{ width: "100%" }}
          beforeChange={handleBeforeChange}
        >
          {bannerList.map((r, i) => (
            <div
              key={i}
              className={styles.card}
              onClick={() => handleClickBanner(r)}
            >
              <img
                alt="banner"
                src={width > 600 ? r?.bannerWeb : r?.bannerMobile}
                className={styles.banner}
              />
            </div>
          ))}
        </Carousel>
      ) : (
        <div style={{ height: 200 }} /> // fallback if no banner
      )}

      <ModalStartTrial
        visible={visibleTrial}
        setVisible={setVisibleTrial}
        doFetch={doFetch}
        handleCancel={() => setVisibleTrial(false)}
        props={props}
      />

      <ModalGetPackage
        visible={visibleGetPkg}
        setVisible={setVisibleGetPkg}
        props={props}
        handleCancel={() => setVisibleGetPkg(false)}
      />
    </div>
  );
};

export default CardBanner;
